import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { EhazSsoApiService } from '../../../services/ehaz/ehaz-sso-api.service';
import { UsersService } from 'src/app/services/users/users.service';
import { LoadingScreenComponent } from '../../../shared/loading-screen/loading-screen.component';

@Component({
  selector: 'app-ehaz-sso',
  templateUrl: './ehaz-sso.component.html',
  styleUrls: ['./ehaz-sso.component.scss'],
  imports: [LoadingScreenComponent],
})
export class EhazSsoComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private eHazSsoApiService = inject(EhazSsoApiService);
  private authService = inject(AuthService);
  private clientsService = inject(ClientsService);
  private usersService = inject(UsersService);

  async ngOnInit(): Promise<void> {
    this.authService.logoutOnUnauthorized = false;
    const token = this.route.snapshot.queryParams.token;
    if (!token) {
      await this.router.navigate(['sso/ehaz/error']);
      return;
    }

    await this.manageEhazSso(token);
  }

  private async manageEhazSso(token: string) {
    try {
      const eHazSsoResult = await this.eHazSsoApiService.eHazSso(token);

      await this.usersService.setUser();

      const client = await this.clientsService.getClient(
        eHazSsoResult.client_id,
      );
      this.clientsService.setSelectedClient(client);

      await this.router.navigateByUrl(`/case/${eHazSsoResult.payee_case_id}`);
    } catch (error) {
      console.log('Error while managing ehaz sso', error);
      await this.router.navigate(['sso/ehaz/error']);
    } finally {
      this.authService.logoutOnUnauthorized = true;
    }
  }
}
